const Icon = (props: any) => (
    <svg
        data-dc-tpl={93}
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path data-dc-tpl={94} d="M8 17l4 4 4-4" />
        <line data-dc-tpl={95} x1={12} y1={12} x2={12} y2={21} />
        <path data-dc-tpl={96} d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29" />
    </svg>
);
export default Icon;

// const Icon = (props: any) => {
//     return (
//         <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
//             <path
//                 d="M19 13v4a2 2 0 01-2 2H3a2 2 0 01-2-2v-4M5 8l5 5 5-5M10 13V1"
//                 stroke="currentColor"
//                 strokeWidth={props.strokeWidth || 1.5}
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//             />
//         </svg>
//     );
// };

// export default Icon;
